<template>
  <article class="loader">
    <section class="loader__container">
      <FuseaccessLogo />
    </section>
  </article>
</template>

<script>
import FuseaccessLogo from "/src/components/shared/icons/FuseaccessLogo.vue";
export default {
  components: {
    FuseaccessLogo
  }
};
</script>

<style lang="css">
@keyframes bounceAndFade {
  0% {
    opacity: 0;
    transform: translateY(-30px); /* Empezamos un poco arriba */
  }
  50% {
    opacity: 1;
    transform: translateY(0); /* Vuelve a su posición normal */
  }
  100% {
    opacity: 0;
    transform: translateY(30px); /* Desaparece un poco hacia abajo */
  }
}

.loader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(200, 200, 200, 0.7);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.loader__container {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader__container {
  animation: bounceAndFade 2s ease-in-out infinite;
  width: 200px;
  height: auto;
}
</style>
